export const MixlrPlayer = () => {
  return (
    <div className="row mixlr">
      <iframe
        src="https://al-madani-masjid.mixlr.com/embed"
        frameBorder="0"
        scrolling="no"
        height="100%"
        width="100%"
        title="Mixlr Live Stream"
      ></iframe>
    </div>
  );
};
